import * as R from "ramda";

import { httpToHttps } from "../../utils/images";

export const getDefaultOfferLetterTemplate = logo => {
  const img = logo
    ? `<img src=${R.replace(
        "https://res.cloudinary.com/dffufplmy/image/upload",
        "https://res.cloudinary.com/dffufplmy/image/upload/w_85,c_scale",
        httpToHttps(logo)
      )}>`
    : "";

  return (
    `<figure class="image image-style-align-left">` +
    img +
    `</figure><p style="text-align:justify;">&nbsp;</p><p style="text-align:justify;">&nbsp;</p><p style="text-align:right;">&nbsp;</p><p style="text-align:right;"><span style="font-family:Verdana, Geneva, sans-serif;">[Ubicación], [Fecha actual]</span></p><p style="text-align:justify;">&nbsp;</p><p style="text-align:justify;"><span style="font-family:Verdana, Geneva, sans-serif;">Estimado [Nombre del Candidato]:</span></p><p style="text-align:justify;">&nbsp;</p><p style="text-align:justify;"><span style="font-family:Verdana, Geneva, sans-serif;">Por medio de la presente le hacemos llegar el contrato para comenzar a trabajar en [Nombre de la Compañía].</span></p><p style="text-align:justify;"><span style="font-family:Verdana, Geneva, sans-serif;">Para el puesto de [Título de la Oportunidad], la fecha de ingreso será [Fecha de ingreso] y su salario [Modalidad] será [Moneda] [Salario].</span></p><p style="text-align:justify;">&nbsp;</p><p style="text-align:justify;"><span style="font-family:Verdana, Geneva, sans-serif;">Por favor, responder en el período de 48 hs hábiles.</span></p><p>&nbsp;</p><p><span style="font-family:Verdana, Geneva, sans-serif;">Atentamente,</span></p><p><span style="font-family:Verdana, Geneva, sans-serif;">[Nombre del Reclutador]</span></p>`
  );
};

export const lastOfferLetter = offer => {
  return R.head(R.sort(R.descend(R.prop("createdAt")), offer));
};

export const capitalize = s => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
